module.exports = __webpack_public_path__ + "img/im_scrollfeature_18@2x.5a6284cd.jpg";